/* eslint-disable simple-import-sort/sort */
import PropTypes from 'prop-types';

import {
    OrderPrintMapType,
    OrderComment,
    OrderComments,
    OrderGrandTotalType,
    OrderTotalType,
    OrderInfoType,
    OrderPaymentInfo,
    OrderPaymentsInfo,
    OrderAddressType as SourceOrderAddressType,
    orderItemQtyType,
    MoneyType,
    DiscountType,
    OptionItemType,
    OptionItemsType,
    OptionType,
    OptionsType,
    OrderProductType,
    OrderProductsType,
    OrderTabType,
    OrderTabsType,
    OrderType as SourceOrderType,
    DownloadableType,
    PageInfoType,
    OrdersType,
    OrdersListType as SourceOrdersListType
} from 'SourceType/Order.type';

export {
    OrderPrintMapType,
    OrderComment,
    OrderComments,
    OrderGrandTotalType,
    OrderTotalType,
    OrderInfoType,
    OrderPaymentInfo,
    OrderPaymentsInfo,
    // OrderAddressType,
    orderItemQtyType,
    MoneyType,
    DiscountType,
    OptionItemType,
    OptionItemsType,
    OptionType,
    OptionsType,
    OrderProductType,
    OrderProductsType,
    OrderTabType,
    OrderTabsType,
    // OrderType,
    DownloadableType,
    PageInfoType,
    OrdersType
    // OrdersListType
};

export const OrderTimelineItemType = PropTypes.shape({
    status: PropTypes.string,
    date: PropTypes.string,
    date_estimated: PropTypes.string,
    label: PropTypes.string
});

export const OrderTimelineType = PropTypes.arrayOf(OrderTimelineItemType);

/**
 * Override
 */
export const OrderType = PropTypes.shape({
    ...SourceOrderType,
    is_favorite: PropTypes.bool,
    timeline: OrderTimelineType
});

export const OrderAddressType = PropTypes.shape({
    ...SourceOrderAddressType,
    company: PropTypes.string
});

export const OrdersListType = PropTypes.shape({
    ...SourceOrdersListType,
    year_filter_options: PropTypes.arrayOf(PropTypes.number)
});
